import styled from "styled-components";

// CLE-2708 — the estimates-page filter bar (CLE-2677), lifted out of OrdersTable so the patients
// page carries the identical search design rather than a second copy of the CSS that drifts from it.
// Only styling lives here: each page keeps its own inputs, filters and layout classes.
export const FilterBar = styled.div`
  border: 1px solid var(--brand-gray-200);
  border-radius: 16px;
  background-color: var(--brand-white);

  .p-input-icon-left > i:first-of-type {
    color: var(--brand-gray-500);
  }

  .p-inputtext,
  .p-multiselect {
    border-radius: 12px;
    border-color: var(--brand-gray-200);
    font-size: 0.875rem;
    color: var(--brand-gray-700);
    box-shadow: 0 1px 2px color-mix(in srgb, var(--brand-black) 5%, transparent),
      0 2px 6px color-mix(in srgb, var(--brand-black) 6%, transparent);
  }

  .p-inputtext::placeholder,
  .p-multiselect .p-multiselect-label.p-placeholder,
  .p-multiselect .p-multiselect-label {
    color: var(--brand-gray-600);
    font-size: 0.875rem;
  }

  .p-multiselect .p-multiselect-trigger,
  .p-calendar .p-inputtext {
    color: var(--brand-gray-600);
  }
`;
